import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { RouterModule, Routes } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { DevelopmentComponent } from "./development.component";

const routes: Routes = [
  {
    path: "development",
    component: DevelopmentComponent,
  },
];
@NgModule({
  declarations: [DevelopmentComponent],
  imports: [
    RouterModule.forChild(routes),
    MatDatepickerModule,
    MatTabsModule,

    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSortModule,
    MatInputModule,
    TranslateModule,
    FormsModule,
    MatNativeDateModule,
  ],
  providers: [MatDatepickerModule],
})
export class DevelopmentModule {}
